import { render, staticRenderFns } from "./Page6.vue?vue&type=template&id=12a60174&scoped=true&"
import script from "./Page6.vue?vue&type=script&lang=js&"
export * from "./Page6.vue?vue&type=script&lang=js&"
import style0 from "./Page6.vue?vue&type=style&index=0&id=12a60174&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a60174",
  null
  
)

export default component.exports